import type { SnackbarState } from '@host/components/NewUI/ComponentsLibrary';

// Module-level notifier bridge. The SnackbarProvider registers its `showSnackbar`
// here on mount so that code running *outside* the React tree — most importantly
// the React Query QueryCache/MutationCache `onError` callbacks in OnboardProviders.tsx —
// can surface a snackbar without holding a React context reference.
//
// Components rendered inside the provider should prefer the `useSnackbar()` hook;
// reach for `notifySnackbar` only from non-component code (query cache callbacks,
// plain async helpers).

export type SnackbarNotifier = (message: string, state: SnackbarState) => void;

let activeNotifier: SnackbarNotifier | null = null;

export const registerSnackbarNotifier = (notifier: SnackbarNotifier | null): void => {
  activeNotifier = notifier;
};

export const notifySnackbar = (message: string, state: SnackbarState): void => {
  activeNotifier?.(message, state);
};
